import styled from '@emotion/styled';

const CenterLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 50vh;
  width: 100%;
  color: var(--dk-text-dim, #b7bbc2);
`;
export { CenterLayout };
